import { TPage } from '~/types/page-types'
import { TRedirect } from '~/types/response-types'
import { useGTMPageView } from '~/composables/useGTM'
import { useNPOTag } from '~/composables/useNPOTag'

// this site uses GTM and NPOTAG analytics
export const useTracking = (data?: TPage | TRedirect) => {
  if (data) {
    useGTMPageView(data as TPage)
    useNPOTag(data as TPage)
  }
}
